import type { LogoDePrixia } from './elegir-logo';

export type TresColores = readonly [string, string, string];

/*
  Constantes de marca, a propósito: `--deg-*` cambia con la apariencia de cada empresa
  y el logo no (spec 344).
*/
export const DEGRADADO_NUEVO: TresColores = ['#5d21b3', '#a32f64', '#df5620'];
const CLASICO: TresColores = ['#5F21B5', '#9B2A7A', '#D9580B'];
const CLASICO_SOBRE_OSCURO: TresColores = ['#7C3AED', '#C2347E', '#EA580C'];

/** Las placas se tiñen entre sí al superponerse, igual que en el logo. */
export const OPACIDAD_DE_PLACA = [0.95, 0.88, 0.82] as const;

export function coloresDelLogo(logo: LogoDePrixia, fondo: 'claro' | 'oscuro'): TresColores {
  if (logo === 'nuevo') return DEGRADADO_NUEVO;
  return fondo === 'oscuro' ? CLASICO_SOBRE_OSCURO : CLASICO;
}
